import './AboutStory.scss';

const AboutStory = () => {
  return (
    <section className="about-story section">
      <div className="wrapper wrapper--medium">
        <div className='row'>
          <div className="col">
            <h2 className="wrapper__title">A Nossa História</h2>
              <p>A Plover nasceu da frustração com sistemas complicados, ferramentas inúteis e conselhos fora da realidade dos pequenos negócios.</p>
              <p>Criámos uma abordagem nova: simples, acessível e adaptada a quem empreende com coragem (e pouco tempo).</p>
          </div>
          <div className='col'>
            <img alt="" src="/images/aboutpage/about-intro.webp" />
          </div>
        </div>
      </div>
    </section>
  );
};
export default AboutStory;